<p class="text-center doc-text-color-disabled mt-3 mb-3"> {{msg}}</p>